import type { ReactNode } from 'react'
import './SectionTitle.css'

export interface SectionTitleProps {
  as?: 'h2' | 'h3'
  children: ReactNode
}

export function SectionTitle({ as = 'h2', children }: SectionTitleProps) {
  const Component = as
  return <Component className="azoya-section-title">{children}</Component>
}
